import { gql } from 'apollo-angular';

/** Prefer latest fold payload — `entries` length changes across `groupBy` modes. */
function mergeOrbitExplorerFoldEntries(existing: unknown, incoming: unknown): unknown {
  if (incoming != null) {
    return incoming;
  }
  if (existing != null) {
    return existing;
  }
  return [];
}

export const ORBIT_EXPLORER_TYPE_POLICY = {
  Query: {
    fields: {
      orbitExplorerFoldGroups: {
        keyArgs: ['groupBy'],
      },
    },
  },
  OrbitExplorerFoldGroup: {
    keyFields: ['id'],
    fields: {
      entries: {
        merge: mergeOrbitExplorerFoldEntries,
      },
    },
  },
};

const ORBIT_EXPLORER_ENTRY_FIELDS = `
  id
  displayName
  functionLabel
  categoryLabel
  surface
  lensSensitive
  sortOrder
  providerCategoryId
  useCaseId
  providerCategory {
    id
    key
    name
    publishedCatalogueVersionId
  }
  useCase {
    id
    name
    key
  }
`;

export const GET_ORBIT_EXPLORER_BUSINESS_CASES = gql`
  query OrbitExplorerBusinessCases($publishedOnly: Boolean!) {
    businessCases(publishedOnly: $publishedOnly) {
      id
      key
      name
      blurb
      iconTone
      sortOrder
      businessCaseIndustries {
        industryId
        industry {
          id
          name
        }
      }
      entries {
        ${ORBIT_EXPLORER_ENTRY_FIELDS}
      }
    }
  }
`;

export const GET_ORBIT_EXPLORER_FOLD_GROUPS = gql`
  query OrbitExplorerFoldGroups($groupBy: String!) {
    orbitExplorerFoldGroups(groupBy: $groupBy) {
      id
      key
      name
      blurb
      iconTone
      sortOrder
      industryName
      businessCaseIndustries {
        industryId
        industry {
          id
          name
        }
      }
      entries {
        ${ORBIT_EXPLORER_ENTRY_FIELDS}
      }
    }
  }
`;
